module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/manual-lottery/manual-lottery.component.css
// module id = ./src/app/allocation/manual-lottery/manual-lottery.component.css
// module chunks = main